import * as _ from 'lodash';
import FactorajeFinancieroCalculator from './FactorajeFinancieroCalculator';

class FactorajeFinancieroTransform {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  static make(data) {
    return new FactorajeFinancieroTransform(data);
  }

  apply() {
    //TODO Podría venir en configuracion para cambios futuros
    let data = this.data || {};

    let { FactorajeFinanciero } = data ?? {};

    if (!!FactorajeFinanciero) {
      FactorajeFinanciero = FactorajeFinancieroCalculator.make(FactorajeFinanciero).apply();

      return {
        ...FactorajeFinanciero,
      };
    }

    data.Equivalencia = '1';
    data.Aforo = data.Aforo ?? 10;
    data.MontoContrato = data.Total ?? 0;
    data.Honorarios = data.Honorarios ?? 1;
    data.TasaInteres = data.TasaInteres ?? 5;

    FactorajeFinanciero = FactorajeFinancieroCalculator.make(data).apply();

    return {
      ...FactorajeFinanciero,
    };
  }
}

export default FactorajeFinancieroTransform;
